import { render, staticRenderFns } from "./WeekTemplateMenu.vue?vue&type=template&id=bb209716&scoped=true&"
import script from "./WeekTemplateMenu.vue?vue&type=script&lang=js&"
export * from "./WeekTemplateMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb209716",
  null
  
)

export default component.exports